import {AccountSettingWithLangRequestDto, ErrorDtoFactory, UserDto} from "../../dtos";
import {Dispatch} from "redux";
import {Action as AccountSettingsWithLangActions} from "../actions/accountSettingsAndLangActions";
import {ActionType} from "../actionTypes";
import axios from "axios";
import envManager from "../../com/envManager/EnvManager";

export const setAccountSettingAndLang = (dataRequest: AccountSettingWithLangRequestDto) => {

    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<AccountSettingsWithLangActions>) => {
        dispatch({
            type: ActionType.SET_ACCOUNT_SETTING_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }
            let result = await axios.post(`${envManager.flyerEditorServerAddress}/api/Account/SetAccountSettings`, dataRequest, config);
            let data = result.data.data
            dispatch({
                type: ActionType.SET_ACCOUNT_SETTING_SUCCESS,
                payload: {
                    accountSetting: data,
                    languageId: dataRequest.languageId
                }
            })
            dispatch({
                type: ActionType.SET_ACCOUNT_SETTING_COMPLETE,
                payload: data
            })
        } catch (err) {
            dispatch({
                type: ActionType.SET_ACCOUNT_SETTING_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}
